import Grid from '@mui/material/Grid';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { useTranslation } from 'react-i18next';
import { useAudienceInsights } from '../../context/audienceInsights.ts';
import { InsightItem } from '../InsightItem/InsightItem.tsx';

export function MonthlyActiveReachEstimates() {
  const { t } = useTranslation();
  const { statistics } = useAudienceInsights();

  return (
    <FormSection title={t('Monthly Active Reach Estimates')} divider>
      <Grid container rowSpacing={8}>
        <Grid size={{ sm: 6, lg: 4, xl: 3 }}>
          <InsightItem
            title={t('Total Monthly Requests')}
            value={statistics.totalMonthly}
            dataTestId="insight-total-monthly-requests"
          />
        </Grid>

        <Grid size={{ sm: 6, lg: 4, xl: 3 }}>
          <InsightItem
            title={t('Total Monthly Active Users')}
            value={statistics.totalActiveUsers}
            dataTestId="insight-total-monthly-active-users"
          />
        </Grid>

        <Grid size={{ sm: 6, lg: 4, xl: 3 }}>
          <InsightItem
            title={t('Total Monthly Active Rampids')}
            value={statistics.totalActiveRampids}
            dataTestId="insight-total-monthly-active-rampids"
          />
        </Grid>
      </Grid>
    </FormSection>
  );
}
